import {UNITS} from "../constants";

export const getUri = (path: string): string => {
  return `${window.location.protocol}//${window.location.host}${path}`
}

export const formattedCurrency = (amount: number | null, currency: 'usd' | 'eur' = 'eur') => {
  const currencySymbol: Record<string, string> = {
    usd: '$',
    eur: '€'
  }

  const sign = currencySymbol[currency] || '€'
  const price = (amount ?? 0).toLocaleString('en-NL')

  return `${sign}${price}`
}

export const getUnitLabel = (value: string): string | undefined => {
  return UNITS.find(unit => unit.value === value)?.label;
};
